import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorStockTransferItem = v.object({
  transferId: v.id("stock_transfers"),
  productId: v.id("products"),
  name: v.string(),
  productCode: v.optional(v.string()),
  quantity: v.number(),
  quantityReceived: v.optional(v.number()),
  unit: v.string(),
  sortOrder: v.optional(v.number()),
  // Recepción enriquecida (traslados inter-sucursal).
  receivedCondition: v.optional(
    v.union(
      v.literal("ok"),
      v.literal("damaged"),
      v.literal("missing"),
    ),
  ),
  receivedNotes: v.optional(v.string()),
  internalControl,
});

export const stock_transfers_items = defineTable(validatorStockTransferItem)
  .index("by_transfer", ["transferId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_product", ["productId"]);
